module.exports = __webpack_public_path__ + "img/iphone11.97c6b501.png";